<!-- 选择模板组件 -->
<template>
    <Drawer v-model="currentVisible" :width="40" :closable="false">
        <Tabs :value="currentTab" @on-click="handleTabChange">
            <TabPane label="关联产品" name="1">
                <Table
                    class="mt24"
                    :columns="columnsTemplate"
                    :data="dataTemplate"
                    border
                >
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <template v-if="currentTemplateId == row.id">
                                <Button type="error" ghost @click="handleCancel(row)">取消</Button>
                            </template>
                            <Button
                                v-else
                                type="primary"
                                ghost
                                @click="handleSelect(1, row)"
                            >使用</Button>
                        </div>
                    </template>
                </Table>
                <Page
                    style="float:right;margin-top: 10px;"
                    :current="prodcut_page.page"
                    :page-size="prodcut_page.limit"
                    :total="prodcut_page.total"
                    show-elevator
                    show-total
                    @on-change="productChange"
                />
            </TabPane>
            <TabPane label="DIY模版" name="2">
                <Table
                    class="mt24"
                    :columns="columnsTemplate"
                    :data="diyTemplate"
                    border
                >
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <template v-if="currentTemplateId == row.id">
                                <Button type="error" ghost @click="handleCancel(row)">取消</Button>
                            </template>
                            <Button
                                v-else
                                type="primary"
                                ghost
                                @click="handleSelect(2, row)"
                            >使用</Button>
                        </div>
                    </template>
                </Table>
                <Page
                    style="float:right;margin-top: 10px;"
                    :current="diy_page.page"
                    :page-size="diy_page.limit"
                    :total="diy_page.total"
                    show-elevator
                    show-total
                    @on-change="diyChange"
                />
            </TabPane>
        </Tabs>
    </Drawer>
</template>

<script>
import { template_result_template, template_diy_list, product_change_template } from "@/api/index";

export default {
    name: 'SelectTemplate',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        templateId: {
            type: [String, Number],
            default: ''
        },
        productId: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            currentVisible: this.visible,
            currentTemplateId: this.templateId,
            columnsTemplate: [
                { type: 'index', width: 60, align: 'center' },
                { title: 'ID', key: 'id', align: 'center' },
                { title: '模板名称', key: 'title', align: 'center' },
                { title: '操作', slot: 'operate', align: 'center', width: '200px' },
            ],
            dataTemplate: [],
            diyTemplate: [],
            prodcut_page: {
                page: 1,
                limit: 10,
                total: 0,
                industry_id: -1,
            },
            diy_page: {
                page: 1,
                limit: 10,
                total: 0,
                industry_id: -1,
            },
            currentTab: '1'
        };
    },
    watch: {
        visible(val) {
            this.currentVisible = val;
            if (val) {
                this.currentTab = '1';
                this.initData();
            }
        },
        currentVisible(val) {
            this.$emit('update:visible', val);
        },
        templateId(val) {
            this.currentTemplateId = val;
        }
    },
    methods: {
        // 初始化数据
        initData() {
            this.getTemplateList();
            this.getDiyList();
        },
        // Tab切换
        handleTabChange(name) {
            this.currentTab = name;
        },
        // 获取关联产品模板列表
        getTemplateList() {
            template_result_template(this.prodcut_page)
                .then(res => {
                    this.dataTemplate = res.data.data;
                    this.prodcut_page.total = res.data.total;
                })
                .catch(err => {
                    this.$Message.error(err.msg);
                });
        },
        // 获取DIY模板列表
        getDiyList() {
            template_diy_list(this.diy_page)
                .then(res => {
                    this.diyTemplate = res.data.data;
                    this.diy_page.total = res.data.total;
                })
                .catch(err => {
                    this.$Message.error(err.msg);
                });
        },
        // 关联产品分页
        productChange(index) {
            this.prodcut_page.page = index;
            this.getTemplateList();
        },
        // DIY分页
        diyChange(index) {
            this.diy_page.page = index;
            this.getDiyList();
        },
        // 选择使用模板
        handleSelect(templateType, row) {
            this.$Modal.confirm({
                title: '提示',
                content: '确认改变使用状态吗？',
                onOk: () => {
                    const data = {
                        product_id: this.productId,
                        template_id: row.id,
                        template_type: templateType,
                    };
                    product_change_template(data)
                        .then(res => {
                            this.currentTemplateId = row.id;
                            this.$emit('change', {
                                template_id: row.id,
                                template_title: row.title,
                                template_type: templateType
                            });
                            this.$Message.success(res.msg);
                            this.currentVisible = false;
                        })
                        .catch(res => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {}
            });
        },
        // 取消使用模板
        handleCancel(row) {
            this.$Modal.confirm({
                title: '提示',
                content: '确认取消使用状态吗？',
                onOk: () => {
                    const data = {
                        product_id: this.productId,
                        template_id: 0,
                        template_type: this.currentTab,
                    };
                    product_change_template(data)
                        .then(res => {
                            this.currentTemplateId = 0;
                            this.$emit('change', {
                                template_id: 0,
                                template_title: row.title,
                                template_type: this.currentTab
                            });
                            this.$Message.success(res.msg);
                            this.currentVisible = false;
                        })
                        .catch(res => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {}
            });
        }
    }
};
</script>
